<template>
    <div class="main">
        <c-panel title="Reservas" titleIcon="fas fa-bookmark">
            <list></list>
        </c-panel>
    </div>
</template>
<script>
import list from "./list"

export default {
    components:{ list }
}
</script>
